import * as storeActions from '@catcore/actions/current-resource';
import {Project} from '@catcore/types/api-v2';
import {ActionWithPayload, CurrentProjectState, Payload, ProcessStatus} from '@catcore/types/base';

const defaultProject: Project = {id: null, name: null, number: null, valid: true, _links: {self: null}};

const initialState: CurrentProjectState = {
  project: {...defaultProject},
  configStatus: null,

};

export const featureName = 'core';

export function currentProjectReducer(state: CurrentProjectState = initialState, action: ActionWithPayload<Payload>) {
  let returnable = state;

  switch (action.type) {
    case storeActions.CORE_CURRENT_PROJECT_UPDATE:
      returnable = {...state, project: action.payload.project};
      break;

    case storeActions.CONFIG_CREATE_START:
      returnable = {...state, configStatus: ProcessStatus.start};
      break;
    case storeActions.CONFIG_CREATE_COMPLETE:
      returnable = {...state, configStatus: ProcessStatus.complete};
      break;
  }

  return returnable;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/reducers/current-project.reducer.ts